<template></template>

<script>
import { loadScript } from "@paypal/paypal-js";
import PaypalCredentials from "../logic/payment/Paypal";

export default {
  methods: {
    async PayPalButtons() {
      paypal
        .Buttons({
          // Sets up the transaction when a payment button is clicked

          createOrder: (data, actions) => {
            this.Booking(true);
            return actions.order.create({});
          },
          // Finalize the transaction after payer approval
          onApprove: (data, actions) => {
            return actions.order.capture().then(function (orderData) {
              // Successful capture! For dev/demo purposes:

              const transaction =
                orderData.purchase_units[0].payments.captures[0];

              alert(
                `Transaction ${transaction.status}: ${transaction.id}\n\nSee console for all available details`
              );
              // When ready to go live, remove the alert and show a success message within this page. For example:
              // const element = document.getElementById('paypal-button-container');
              // element.innerHTML = '<h3>Thank you for your payment!</h3>';
              // Or go to another URL:  actions.redirect('thank_you.html');
            });
          },
        })
        .render("#paypal-button-container");
    },
  },
  async mounted() {
    let paypal;
    let clientID = await PaypalCredentials.get();
    

    try {
      paypal = await loadScript({
        "client-id": clientID,
      });
    } catch (error) {
      console.error("failed to load the PayPal JS SDK script", error);
    }

    if (paypal) {
      try {

        await this.PayPalButtons();
      } catch (error) {
        console.error("failed to render the PayPal Buttons", error);
      }
    }
  },
};
</script>

<style>
</style>